import { render, staticRenderFns } from "./serviceView.vue?vue&type=template&id=0c5919f9&scoped=true"
import script from "./serviceView.vue?vue&type=script&lang=js"
export * from "./serviceView.vue?vue&type=script&lang=js"
import style0 from "./serviceView.vue?vue&type=style&index=0&id=0c5919f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5919f9",
  null
  
)

export default component.exports